<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate>Calendar</h3>
    </div>
    <ng-template ngxPermissionsOnly="canViewOtherUsersTasks">
      <div class="card-toolbar">
        <div>
          <button
            class="mr-2"
            mat-button
            [ngClass]="isMyFollowup ? 'filter-button-active' : 'default-button'"
            color="{{ isMyFollowup ? 'primary' : '' }}"
            (click)="fetchMyFollowups()"
          >
            My Follow-Ups
          </button>
        </div>
        <div>
          <button
            class="mr-2"
            mat-button
            [ngClass]="isTeamFollowups ? 'filter-button-active' : 'default-button'"
            color="{{ isTeamFollowups ? 'primary' : '' }}"
            (click)="fetchFollowingTasks()"
          >
            Team Follow-Ups
          </button>
        </div>
        <div class="btn-group">
          <button
            class="btn btn-sm btn-clean mr-2 dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            FILTER
            <i class="ml-2 ki ki-arrow-down text-primary"></i>
          </button>
          <div
            class="dropdown-menu p-5 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg"
            aria-labelledby="dropdownMenuButton"
            (click)="$event.stopPropagation()"
          >
            <mat-form-field class="col-md-6" appearance="standard" style="padding-left: 0">
              <mat-label>From Date</mat-label>
              <input
                matInput
                [matDatepicker]="fromPicker"
                [formControl]="fromDate"
                placeholder="MM/DD/YYYY"
                (dateChange)="loadFollowups()"
                ktDateMask
                maxlength="10"
                [matDatepickerFilter]="startFilter.bind(parent)"
              />
              <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
              <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="col-md-6" appearance="standard" style="padding-right: 0">
              <mat-label>To Date</mat-label>
              <input
                matInput
                [matDatepicker]="toPicker"
                [formControl]="toDate"
                placeholder="MM/DD/YYYY"
                (dateChange)="loadFollowups()"
                ktDateMask
                maxlength="10"
                [matDatepickerFilter]="toFilter.bind(parent)"
              />
              <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
              <mat-datepicker #toPicker></mat-datepicker>
            </mat-form-field>
            <kt-general-autocomplete
              [label]="'User'"
              [loadItemsFunction]="searchUsers"
              [optionFormatter]="displayFn"
              [valueFormatter]="displayFnSelected"
              [required]="false"
              [readOnly]="false"
              [control]="userCtrl"
              [change]="userSelected.bind(this)"
              [placeholder]="'Search User'"
              [dataPath]="'data'"
              [appearance]="'standard'"
            ></kt-general-autocomplete>
            <kt-general-autocomplete
              [label]="'Contact'"
              [loadItemsFunction]="contactAutocompleteCall"
              [optionFormatter]="stringUtils.displayName"
              [valueFormatter]="stringUtils.displayName"
              [required]="false"
              [readOnly]="false"
              [control]="contactCtrl"
              [change]="onContactChange.bind(this)"
              [dataPath]="'data'"
              [appearance]="'standard'"
              [placeholder]="'Select Contact'"
            ></kt-general-autocomplete>
            <mat-form-field appearance="standard" class="mat-form-field-fluid">
              <mat-label>Type</mat-label>
              <mat-select [(value)]="type" (selectionChange)="loadFollowups()">
                <mat-option>None</mat-option>
                <mat-option value="MEETING">Meeting</mat-option>
                <mat-option value="FILTERED_SESSION">Filtered Session</mat-option>
                <mat-option value="NOTE">Note</mat-option>
                <mat-option value="TASK">Task</mat-option>
                <mat-option value="MEDREVIEW">MedReview</mat-option>
                <mat-option value="WORKFLOW">Events</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
    <full-calendar [options]="calendarOptions"></full-calendar>
  </div>
  <div class="card-footer">
    <div class="row">
      <div class="col-lg-9">
        <table>
          <tr>
            <td>
              <div>
                <span class="label label-dot label-success label-view"></span>
                <span class="font-weight-bold text-muted font-size-sm">Active </span>
              </div>
            </td>
            <td>
              <div>
                <span
                  class="label label-dot label-primary label-view"
                  style="margin-left: 17px"
                ></span>
                <span class="font-weight-bold text-muted font-size-sm">Completed </span>
              </div>
            </td>
            <td>
              <div>
                <span class="label label-dot label-danger label-view"></span>
                <span class="font-weight-bold text-muted font-size-sm">Cancelled </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="col-lg-3" style="text-align: right">
        <button
          (click)="close()"
          type="button"
          mat-raised-button
          cdkFocusInitial
          matTooltip="Cancel"
        >
          <span translate="GLOBAL.CLOSE">Close</span>
        </button>
      </div>
    </div>
  </div>
</div>
